import CollapseableItem from 'common/CollapseableItem'
import CollapseablePannel from 'common/CollapseablePannel'
import Integrations from 'pages/Settings/components/Integrations'
import SetNotifications from 'pages/Settings/components/SetNotifications'
import React, { useEffect } from 'react'
import ReactDOMServer from 'react-dom/server';
import { useState } from 'react';
import { withAlert } from 'react-alert';
import InstitutionPreference from '../InstitutionsDetails/components/InstitutionSettings/InstitutionPreference'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { InstitutionServices } from 'utils/InstitutionServices'
import { PractitionerService } from "utils/PractitionerService";
import { getLoggedInUserInstitutions, isAdmin } from 'utils/UserHelper'
import { ButtonDropdown, Card, CardBody, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom'
import PreviewWindow from 'pages/UIDashboard/Components/CustomThemeDesign/PreviewWindow'
import ThemeOne from 'pages/UIDashboard/Components/CustomThemeDesign/ThemeOne'
import ThemeTwo from 'pages/UIDashboard/Components/CustomThemeDesign/ThemeTwo'
import ThemeThree from 'pages/UIDashboard/Components/CustomThemeDesign/ThemeThree'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import AdminUsers from './AdminUsers'
import ConfigurePage from './ConfigurePage'


const InstitutionsAdmin = (props) => {
    const { alert } = props;
    const location = useLocation();
    const currentUser = useSelector((state) => state.auth.currentUser);
    const { state } = location;
    const params = useParams();
    const [otherBranches, setOtherBranches] = useState([]);
    const [oBranchFlag, setOBranchFlag] = useState(false);
    const [practitioners, setPractitioners] = useState([]);
    const [institution, setInstitution] = useState({});
    const history = useHistory();
    const loggedInUserInstitutions = getLoggedInUserInstitutions();
    const [instituteThemeDetails, setInstituteThemeDetails] = useState(null);
    const [Loader, setLoader] = useState(false);
    const [modal, setModal] = useState(false);
    const [awards, setAwards] = useState([]);
    const currentUserId = currentUser.guid;
    // const toggle = () => {
    //     setModal(!modal);
    // };

    const getInstituteThemeDetails = async (instguid) => {
        await InstitutionServices.getDisplayPreferences(instguid)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setInstituteThemeDetails(data);
                }
                else {
                    setInstituteThemeDetails({});
                }
            })
    }

    const checkIfLoginUserIsAdminOfCurrentInstitution = () => {
        let url = window.location.pathname;
        const myArray = url.split("/");
        let profileId = myArray[myArray.length - 2];

        InstitutionServices.getInstitutionById(profileId)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setInstitution(data);
                    if (!(loggedInUserInstitutions && loggedInUserInstitutions.includes(data?.guid)) && !isAdmin()) {
                        history.push("/404");
                    }
                } else {
                    history.push("/404");
                }
            })
    };

    useEffect(() => {
        checkIfLoginUserIsAdminOfCurrentInstitution();
    }, [])

    useEffect(() => {
        if (institution?.guid) {
            getInstituteThemeDetails(institution?.guid);
        }
    }, [institution?.guid]);

    const [active_setting_pannel, setActive_setting_pannel] = useState('theme');


    function active_pannel_handle(evt, val) {
        evt.preventDefault();
        setActive_setting_pannel(val);
    }

    const getAllOtherBranches = async () => {
        setOBranchFlag(true);
        const response = await InstitutionServices.instituteOtherLocation(
            institution?.profileId
        );
        if (response.status === 200) {
            const { data } = response;
            data.map((obranch, id) => {
                if (obranch.avatarId) {
                    const imageSet = `${process.env.REACT_APP_IMAGE_BASE_URL}/${obranch.guid}/${obranch.avatarId}`;
                    data[id].imageSource = imageSet;
                }
            })
            setOBranchFlag(true);
            let instOBranches = data.filter(obranch => obranch.profileId !== institution.profileId);
            setOtherBranches(instOBranches);
        } else {
            setOBranchFlag(false);
        }
    };

    const getlistOfawards = async () => {
        const response = await InstitutionServices.awardsInstitution(
            institution?.guid
        );
        if (response.status === 200) {
            setAwards(response.data);
        }
    };

    useEffect(() => {
        if (institution?.guid) {
            getlistOfawards();
        }
    }, [institution?.guid]);

    useEffect(() => {
        PractitionerService.getPractitionersAssociatedtoInstitutionWithPagination(
            institution?.guid
        ).then((response) => {
            const { status, data } = response;
            if (status === 200) {
                setPractitioners(data.contents);
            } else {
                console.log("Something went wrong");
            }
        });
    }, [institution]);

    useEffect(() => {
        if (institution?.profileId) {
            getAllOtherBranches();
        }
    }, [institution?.profileId])

    return (
        Loader ? (
            <div className="d-flex justify-content-center mt-3">
                <div className="loading-spiner">
                    <Spinner style={{ width: "2rem", height: "2rem" }} />
                </div>
            </div>
        ) : (
            <div className='nex-institution-admin-wrap'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 mb-3 nex-app-no-pad">
                            <div className="nexogic-sidebar-stiky">
                                <ul className="nexogic-aside-menu card">
                                    {process.env.REACT_APP_HIDE_STATIC_CONTENT === 'false' &&
                                        <li className={`nav-item ${active_setting_pannel === 'users' ? 'active' : ''}`}>
                                            <a href=" " onClick={(e) => active_pannel_handle(e, 'users')} className='nav-link'>
                                                <span className='icon'><svg width="32" height="27" viewBox="0 0 32 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22.8182 26V23.2222C22.8182 21.7488 22.2435 20.3357 21.2206 19.2939C20.1977 18.252 18.8103 17.6667 17.3636 17.6667H6.45455C5.00791 17.6667 3.62053 18.252 2.5976 19.2939C1.57467 20.3357 1 21.7488 1 23.2222V26M31 26V23.2222C30.9991 21.9913 30.5968 20.7955 29.8564 19.8227C29.116 18.8498 28.0793 18.155 26.9091 17.8472M21.4545 1.18056C22.6278 1.48653 23.6678 2.18153 24.4104 3.15599C25.1531 4.13044 25.5561 5.32893 25.5561 6.5625C25.5561 7.79607 25.1531 8.99456 24.4104 9.96901C23.6678 10.9435 22.6278 11.6385 21.4545 11.9444M17.3636 6.55556C17.3636 9.6238 14.9216 12.1111 11.9091 12.1111C8.89663 12.1111 6.45455 9.6238 6.45455 6.55556C6.45455 3.48731 8.89663 1 11.9091 1C14.9216 1 17.3636 3.48731 17.3636 6.55556Z" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                </span>Users</a>
                                        </li>
                                    }
                                    <li className={`nav-item  ${active_setting_pannel === 'theme' ? 'active' : ''}`}>
                                        <a href=" " onClick={(e) => active_pannel_handle(e, 'theme')} className='nav-link'>
                                            <span className='icon'>
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 3.12132H3C2.46957 3.12132 1.96086 3.33203 1.58579 3.70711C1.21071 4.08218 1 4.59089 1 5.12132V19.1213C1 19.6518 1.21071 20.1605 1.58579 20.5355C1.96086 20.9106 2.46957 21.1213 3 21.1213H17C17.5304 21.1213 18.0391 20.9106 18.4142 20.5355C18.7893 20.1605 19 19.6518 19 19.1213V12.1213M17.5 1.62132C17.8978 1.2235 18.4374 1 19 1C19.5626 1 20.1022 1.2235 20.5 1.62132C20.8978 2.01915 21.1213 2.55871 21.1213 3.12132C21.1213 3.68393 20.8978 4.2235 20.5 4.62132L11 14.1213L7 15.1213L8 11.1213L17.5 1.62132Z" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>Configure</a>
                                    </li>
                                    {process.env.REACT_APP_HIDE_STATIC_CONTENT === 'false' &&
                                        <li className={`nav-item  ${active_setting_pannel === 'analytics' ? 'active' : ''}`}>
                                            <a href=" " onClick={(e) => active_pannel_handle(e, 'analytics')} className='nav-link'>
                                                <span className='icon'>
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.2104 14.89C19.5742 16.3945 18.5792 17.7202 17.3123 18.7513C16.0454 19.7824 14.5452 20.4874 12.9428 20.8048C11.3405 21.1221 9.68483 21.0421 8.12055 20.5718C6.55627 20.1014 5.13103 19.2551 3.96942 18.1067C2.80782 16.9582 1.94522 15.5428 1.45704 13.9839C0.968859 12.4251 0.869965 10.7705 1.169 9.16463C1.46804 7.55878 2.1559 6.05063 3.17245 4.77203C4.189 3.49343 5.50329 2.48332 7.0004 1.83M21.0004 11C21.0004 9.68678 20.7417 8.38642 20.2392 7.17317C19.7367 5.95991 19.0001 4.85752 18.0715 3.92893C17.1429 3.00035 16.0405 2.26375 14.8272 1.7612C13.614 1.25866 12.3136 1 11.0004 1V11H21.0004Z" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>Analytics</a>
                                        </li>
                                    }
                                    <li className={`nav-item  ${active_setting_pannel === 'settings' ? 'active' : ''}`}>
                                        <a href=" " onClick={(e) => active_pannel_handle(e, 'settings')} className='nav-link'>
                                            <span className='icon'>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>Settings</a>
                                    </li>
                                </ul>
                                <Card className='mt-2'>
                                    <CardBody>
                                        <a
                                            href={`${process.env.REACT_APP_WEBSITE_URL}/institutions/${institution?.profileId}`}
                                            target="_blank"
                                        >
                                            Visit Nexogic Website
                                        </a>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                        <div className="col-lg-9 nex-app-no-pad">
                            {active_setting_pannel === 'users' &&
                                <AdminUsers institution={institution} />
                            }
                            {/* customized */}
                            {active_setting_pannel === 'theme' &&
                                <ConfigurePage institution={institution} instituteThemeDetails={instituteThemeDetails} otherBranches={otherBranches} practitioners={practitioners} awards={awards} currentUserId={currentUserId} />
                            }

                            {active_setting_pannel === 'analytics' &&
                                <CollapseablePannel title="Analytics">
                                    Coming Soon.
                                </CollapseablePannel>
                            }

                            {/* setting tabs */}
                            {active_setting_pannel === 'settings' &&
                                <CollapseablePannel title="Settings">

                                    {process.env.REACT_APP_HIDE_STATIC_CONTENT === "false" &&
                                        <CollapseableItem title="Integrations">
                                            <Integrations isTitle={false} />
                                        </CollapseableItem>
                                    }

                                    {institution &&
                                        <CollapseableItem title="Preferences">
                                            <InstitutionPreference isTitle={false} institution={institution} />
                                        </CollapseableItem>
                                    }
                                    {process.env.REACT_APP_HIDE_STATIC_CONTENT === "false" &&
                                        <CollapseableItem title="Set Notifications">
                                            <SetNotifications isTitle={false} />
                                        </CollapseableItem>
                                    }

                                </CollapseablePannel>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}
export default withAlert()(InstitutionsAdmin);
